import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LicenseService } from '@core/services';

/**
 * Protects the /organization routes.
 * Only users with organization_role = 'organizational_admin' can access.
 */
export const orgAdminGuard: CanActivateFn = async () => {
  const licenseService = inject(LicenseService);
  const router = inject(Router);

  // Context should already be loaded by authGuard, but ensure it
  if (!licenseService.getAccessContext()) {
    await licenseService.loadAccessContext();
  }

  if (!licenseService.isOrgAdmin) {
    router.navigate(['/dashboard']);
    return false;
  }

  return true;
};
